import { UnderConstruction } from "../../ui/UnderConstruction";
import { createWebsiteStore } from "../website/store";
import { ModuleShell } from "./ModuleShell";

const MODULE_COPY: Record<string, { title: string; detail: string }> = {
  map: {
    title: "Map",
    detail:
      "Map will turn scan inventory into a published content architecture. No map output exists yet.",
  },
  brief: {
    title: "Brief",
    detail:
      "Brief will generate build specifications from priority findings. No brief output exists yet.",
  },
  govern: {
    title: "Govern",
    detail:
      "Govern will run QA, workflow and approval cycles for shipped content. No governance output exists yet.",
  },
  help: {
    title: "Help",
    detail: "In-product help and documentation are not available yet.",
  },
};

/** Route target for every Faro Signal module that is not built yet. */
export function ComingSoon(props: { websiteId: string; module: string }) {
  const context = createWebsiteStore(props.websiteId);
  const copy = () =>
    MODULE_COPY[props.module] ?? {
      title: "Coming soon",
      detail: "This part of Faro Signal is not built yet.",
    };
  const activeModule = () =>
    props.module === "map" ||
    props.module === "brief" ||
    props.module === "govern"
      ? props.module
      : "none";

  return (
    <ModuleShell context={context} activeModule={activeModule()}>
      <UnderConstruction
        title={copy().title}
        detail={copy().detail}
        backHref={`/w/${props.websiteId}/overview`}
      />
    </ModuleShell>
  );
}
